export default __webpack_public_path__ + "static/media/screen_5.d2251b3c.png";